import * as actionName from "./../modules/actions";
import Immutable from 'immutable';

function initialState(currentAccID) {
	return Immutable.fromJS({ task: {}, modals: [] });
};

export default function(state = initialState(), action) {
	action = Immutable.fromJS(action);
	switch (action.get('type')) {
		case actionName.DATAFETCH:
			var data = action.get('data');
			state = state.set('notices', data.get('notices'));
			state = state.set('task', data.get('task'));
			state = state.set('bvKeyMigrationEnabled', data.get('bv_key_migration_enabled'))
			state = state.set('httpMigrationEnabled', data.get('http_migration_enabled'))
			state = state.set('cwsAutoscaleEnabled', data.get('cws_autoscale_enabled'))
			state = state.set('showAutomatticHost', data.get('show_automattic_host'))
			return state;
		case actionName.ADDMODAL:
			var modals = state.get('modals');
			modals = modals.push(action.get('params'));
			return state.set('modals', modals);
		case actionName.REMOVEMODAL:
			return state.set('modals', state.get('modals').shift());
		default:
			return state;
	}
}
